import React, { useEffect } from 'react'

import request from '@function/ajax/request'

export default function LoadPrivateSale ({ onSuccess, onError, ...props })
{
	const is__admin = props.admin === true;

	useEffect(function ()
	{
		const controller = new AbortController();

		(async function ()
		{
			const url = is__admin
			? '/private-sales/get-admin'
			: '/private-sales/get';

			try
			{
				var response = await request(url)
				.config({ controller, keyword: 'ressource' })
				.post({ slug: props.slug });

				onSuccess(response.private_sale);
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;

				onError(update);
			}
		})();

		return () => { controller.abort?.(); };
	},
	[is__admin]);

	return null;
}